// Same value as ANIMATION_PRE_DELAY in the reader, so both run the commands of an action in the same order
const ANIMATION_DEFER_DELAY = 100;

// A button action is a list of commands. playAnimation(), reverseAnimation(), onShow() and onHide() each display
// the MSO state of their target, so the last one to run wins. inDesign runs them in writing order, so a closing
// onHide() on an element of another state hides the popup the animation has just opened. The reader postpones
// animations so they run last; doing the same here keeps the Editor consistent with it.
const getDeferredAnimationsScript = (): string => `
;(function() {
	var animationFunctionNames = ['playAnimation', 'reverseAnimation'];

	for (var i = 0; i < animationFunctionNames.length; i++) {
		(function(functionName) {
			var originalFunction = window[functionName];

			if (typeof originalFunction !== 'function') {
				return;
			}

			window[functionName] = function() {
				var args = arguments;

				setTimeout(function() {
					originalFunction.apply(null, args);
				}, ${ANIMATION_DEFER_DELAY});
			};
		})(animationFunctionNames[i]);
	}
})();
`;

export const getModifiedScripts = (scripts: string): string => {
	// we have to remove these statements from inDesign generated script for enabling text selection in buttons
	const eventStatementsToReplace = 'event\\.stopPropagation\\(\\);|event\\.preventDefault\\(\\);';
	const eventStatementsRegExp = new RegExp(eventStatementsToReplace, 'g');

	// tslint:disable-next-line: max-line-length
	// Some methods in inDesign generated script (e.g., handleAnimationInMSOState) get className property for each element inside MSO including elements which are added in Editor like action buttons. These buttons have svg icons inside. The className property on an svg element returns an object, not a string as for any html element. So calling indexOf on this object breaks inDesign script. The solution is to exclude <svg> and <use> elements.
	const selectorStatementsToReplace = `getElementsByTagName\\(\\'\\*\\'\\);`;
	const selectorStatementsRegExp = new RegExp(selectorStatementsToReplace, 'g');

	return scripts
		.replace(eventStatementsRegExp, '')
		.replace(selectorStatementsRegExp, `querySelectorAll('*:not(svg):not(use)');`)
		.concat(getDeferredAnimationsScript());
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/scripts.ts